<template>
  <div>
    <table class="table-list table-responsive">
      <thead>
      <tr>
        <th style="white-space: nowrap" v-for="title in titles" :key="title.id">{{ title.name }}</th>
      </tr>
      </thead>
      <ItemForm
        v-for="item in items"
        :key="item.id"
        :initialItem="item"
        v-on:addNewRow="addNewRow"
        v-on:deleteRow="deleteRow"
      />
    </table>

   <setion class="d-flex  ">
    <div class="content table-responsive" style="white-space: nowrap">
      <h4 class="text-dark p-3 pl-5">Search Result</h4>
      <div class="d-flex pl-5" >
        <b-button class="bg-gray text-white">Download</b-button>
        <b-button class="bg-gray text-white ml-5">Add Selected</b-button>
        <b-button class="bg-gray text-white ml-3">Add All</b-button>
      </div>
      <table class="search-table-list ">
        <div class="search-content">
          <thead >
            <tr   >
              <th v-for="name in names" :key="name.id">{{ name.name }}</th>
            </tr>
          </thead>
          <ItemSearchResult

            v-for="item in search"
            :key="item.id"
            :initialItem="item"
          />
        </div>
      </table>
    </div>

    <div class="content-queues table-responsive "style="white-space: nowrap" >
      <h4 class="text-gr p-3 pl-5">ORDER QUEUE</h4>
      <div class="d-flex pr-5 justify-content-end">
        <b-button class="bg-gray text-white ml-3">Remove All</b-button>
      </div>
      <table class="queue-table-list">
        <div class="search-content">
          <thead>
          <tr>
            <th v-for="name in queue_item_names" :key="name.id">{{ name.name }}</th>
          </tr>
          </thead>
           <QueueItems
             v-for="item in queue_items"
             :key="item.id"
             :initialItem="item"
           />
        </div>
      </table>
    </div>

  </setion>
  </div>
</template>

<script>
import ItemForm from "./ItemForm";
import ItemSearchResult from "./ItemSearchResult";
import QueueItems from "./QueueItems";
export default {
  components: {QueueItems, ItemForm, ItemSearchResult},
  data() {
    return {
      items: [
        {
          id: 1,
          options: [
            { value: 1, text: 'AR' },
            { value: 2, text: 'AM' },
            { value: 3, text: 'SG' },
            { value: 4, text: 'SN'},
            { value: 5, text: 'LG'}
          ],
          color: [
            { value: 1, text: '#0048BA' },
            { value: 2, text: '#B0BF1A' },
            { value: 3, text: '#7CB9E8' },
            { value: 4, text: '#C0E8D5'},
            { value: 5, text: '#B284BE'}
          ],
          rate_center: '',
          tier: [
            { value: 1, text: '#0048BA' },
            { value: 2, text: '#B0BF1A' },
            { value: 3, text: '#7CB9E8' },
            { value: 4, text: '#C0E8D5'},
            { value: 5, text: '#B284BE'}
          ],
          telephone_number: '',
          telephone_numberSec: '',
          telephone_numberThr: '',
          city: 1,
          wildcard: false,
          sequential: false,
          on_net_only: false,
          local: false,
          result: '1/1'
        }
      ],
      titles: [
        {id: 1, name: 'STATE'},
        {id: 2, name: 'LATA'},
        {id: 3, name: 'RATE CENTER'},
        {id: 4, name: 'TIER'},
        {id: 5, name: 'TELEPHONE NUMBER'},
        {id: 7, name: 'CITY'},
        {id: 8, name: 'WILDCARD'},
        {id: 8, name: 'SEQUENTIAL'},
        {id: 8, name: 'ON-NET ONL'},
        {id: 8, name: 'LOCAL'},
        {id: 8, name: ''},
        {id: 8, name: 'RESULT'},
      ],
      names: [
        {id: 1, name: 'LATA'},
        {id: 2, name: 'RATE CENTER'},
        {id: 3, name: 'STATE'},
        {id: 4, name: 'TELEPHONE NUMBER'},
        {id: 5, name: 'TIER'},
        {id: 6, name: 'ADD TO QUEUE'},
      ],
      search: [
        {
          id: 1,
          lata: '25%',
          rate_center: 'Mansfield',
          state: 'AR',
          telephone_number: '498758945',
          tier: '1',
          add_to: false,
        },
        {
          id: 2,
          lata: '45%',
          rate_center: 'Mansfield',
          state: 'SR',
          telephone_number: '5448945',
          tier: '2',
          add_to: true,
        },
        {
          id: 3,
          lata: '14%',
          rate_center: 'Mansfield',
          state: 'RT',
          telephone_number: '498758945',
          tier: '3',
          add_to: false,
        }
      ],
      queue_item_names: [
        {id: 1, name: 'LATA'},
        {id: 2, name: 'RATE CENTER'},
        {id: 3, name: 'STATE'},
        {id: 4, name: 'TELEPHONE NUMBER'},
        {id: 5, name: 'REMOVE'},
      ],
      queue_items: [
        {
          id: 1,
          lata: '25%',
          rate_center: 'Mansfield',
          state: 'AR',
          telephone_number: '498758945',
        },
        {
          id: 2,
          lata: '45%',
          rate_center: 'Mansfield',
          state: 'SR',
          telephone_number: '5448945',
        },
      ],
    }
  },
  methods: {
    addNewRow(data) {
      if(!data) return
      this.items.push(data)
    },
    deleteRow(id) {
      if(!id) return
      this.items = this.items.filter(el => el.id !== id)
    }
  },
}
</script>

<style scoped lang="scss">
.table-responsive{
  width: 100% !important;
  overflow-x: auto;
  display: block;
}
.table-list {
  width: 83%;
  border-radius: 6px;
  thead {
    tr {
      th {
        color: #1acad2;
        padding: 0 10px;
      }
    }
  }
}
.content {
  margin-top: 50px;
  background: white;
  border: 1px solid #c9c8c7;
  border-radius: 6px;
  width: 100%;
  max-width: 650px;
  .search-table-list {
    .search-content {
      padding: 25px 25px;
    }
    thead {
      tr {
        th {
          color: #1acad2;
        }
      }
    }
  }
}
.content-queues {
  margin-top: 50px;
  margin-left: 70px;
  background: #f3f3f3 ;
  border: 1px solid #c9c8c7;
  border-radius: 6px;
  width: 100%;
  max-width: 600px;
  .queue-table-list {
    .search-content {
      padding: 25px 25px;
    }
    thead {
      tr {
        th {
          color: #1acad2;
        }
      }
    }
  }
}
</style>


